export default __webpack_public_path__ + "static/media/RUBRIQUEKOJY-QUIZZ.764957b5.png";